import React, { useRef, useLayoutEffect } from "react";
import OneXButton from "./OneXButton";

const OneXModal = ({
    id,
    title,
    body,

    // Primary Button Information
    primaryId=null,
    primaryLabel,
    primaryClickHandler,
    primaryKeyPress,

    //Secondary Button Information
    secondaryId=null,
    secondaryLabel,
    secondaryClickHandler,
    secondaryKeyPress,
}) => {
    const wrapperRef = useRef(null);

  useLayoutEffect(() => {

    const currentRef = wrapperRef.current;

    window.oneX.addElement(currentRef);

    return () => {
      window.oneX.removeElement(currentRef);
    }
    });

    useLayoutEffect(() => {
        if(primaryId!=null) {
            document.getElementById(`${primaryId}`).onmousedown = primaryClickHandler;
            document.getElementById(`${primaryId}`).onkeydown = primaryKeyPress;
        }
        if(secondaryId!=null) {
            document.getElementById(`${primaryId}`).onmousedown = secondaryClickHandler;
            document.getElementById(`${primaryId}`).onkeydown = secondaryKeyPress;
        }
    });

    return (
        <div ref={wrapperRef} id={id} className="-oneX-modal__container" style={{display:"none"}} >
            <div className="-oneX-modal-content" aria-labelledby={`${id}-content`} role="dialog">
                <div id={`${id}-content`} className="-oneX-modal-heading" role="heading" aria-level="2" tabIndex="-1">{title}</div>
                <div className="-oneX-modal-body">
                    {body}
                </div>
                <div className="-oneX-modal-footer">
                    <div className="-oneX-row">
                        {primaryId != null ?
                        <div className="-oneX-modal-primary__div -oneX-col">
                            <OneXButton
                                id={primaryId}
                                type={"primary"}
                            >
                                {primaryLabel}
                            </OneXButton>
                        </div>
                        : null}
                        {secondaryId != null ?
                        <div className="-oneX-modal-secondary__div -oneX-col">
                            <OneXButton
                            id={secondaryId}
                            type={"secondary"}
                            >
                                {secondaryLabel}
                            </OneXButton>
                        </div>
                        : null}
                    </div>
                </div>
                <button type="button" className="-oneX-close-X-button" aria-label="Close Modal">
                    <span className="-oneX-icon--close">
                    </span>
                </button>
            </div>
        </div>
    )
}

export default OneXModal;
